import SelectNorm from './SelectNorm';

export default SelectNorm;